import { calculateDuration } from './utils/calculateDuration.js';
/**
 * @internal
 *
 * Maps SegmentList from dash to Segment list from ham.
 *
 * @param segmentList - SegmentList list from dash
 * @returns list of ham segments
 */
export function mapSegmentList(segmentList) {
    const segments = [];
    segmentList.map((segment) => {
        if (segment.SegmentURL) {
            return segment.SegmentURL.forEach((segmentURL) => {
                var _a;
                segments.push({
                    duration: calculateDuration(segment.$.duration, segment.$.timescale),
                    url: (_a = segmentURL.$.media) !== null && _a !== void 0 ? _a : '',
                });
            });
        }
    });
    return segments;
}
//# sourceMappingURL=mapSegmentList.js.map